import {
  Box,
  Chip,
  Container,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { pink } from "@mui/material/colors";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-hot-toast";
import Title from "../../../../components/title";
import { LoadingTable } from "../../../../components/Loading/LoadingTable";
import { NoData } from "../../../../components/NoData/NoData";
import { StyledTableCell } from "../../../franchise/components/StyledTableCell";
import crmGestanteMensagensService from "../../../../services/crmGestanteMensagens";
import { PermissionsPage } from "../../../../util/permissionsPage";

const TIPO_COLORS = {
  SEMANA: "primary",
  NIVEL: "success",
  PADRAO: "default",
  PRIMEIRO_CONTATO: "warning",
  FOLLOWUP_PRIMEIRO_CONTATO: "info",
};

const TIPO_LABELS = {
  SEMANA: "SEMANA",
  NIVEL: "NÍVEL",
  PADRAO: "PADRÃO",
  PRIMEIRO_CONTATO: "1º CONTATO",
  FOLLOWUP_PRIMEIRO_CONTATO: "FOLLOW-UP",
};

export const MensagensList = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getData = async () => {
    setIsLoading(true);
    try {
      const response = await crmGestanteMensagensService.listar();
      setData(response.data);
    } catch (error) {
      toast.error("Erro ao buscar mensagens");
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Deseja excluir esta mensagem?")) return;
    try {
      await crmGestanteMensagensService.deletar(id);
      toast.success("Mensagem excluída com sucesso");
      getData();
    } catch (error) {
      toast.error("Erro ao excluir mensagem");
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {PermissionsPage("crmGestanteMensagens") && (
        <>
          <Container className="containerFlexBox">
            <Title title="MENSAGENS CRM GESTANTE" />
          </Container>

          <Box
            component={Container}
            marginY={2}
            display="flex"
            justifyContent="flex-end"
          >
            <Tooltip title="Cadastrar nova mensagem">
              <IconButton
                size="small"
                sx={{ color: pink[400] }}
                onClick={() => history.push("/crm-gestante/mensagens/criar")}
              >
                <AddBoxIcon sx={{ width: 50, height: 50 }} />
              </IconButton>
            </Tooltip>
          </Box>

          {isLoading ? (
            <LoadingTable />
          ) : (
            <Container sx={{ paddingBottom: "2rem" }}>
              {data.length === 0 ? (
                <Box width="100%" display="flex" justifyContent="center" alignItems="center">
                  <NoData />
                </Box>
              ) : (
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer>
                    <Table stickyHeader size="small">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>Tipo</StyledTableCell>
                          <StyledTableCell>Semana</StyledTableCell>
                          <StyledTableCell>Nível</StyledTableCell>
                          <StyledTableCell>Prévia da mensagem</StyledTableCell>
                          <StyledTableCell>Ações</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.map((row) => (
                          <TableRow key={row.id} hover>
                            <TableCell>
                              <Chip
                                label={TIPO_LABELS[row.tipo] ?? row.tipo}
                                color={TIPO_COLORS[row.tipo] ?? "default"}
                                size="small"
                              />
                            </TableCell>
                            <TableCell>{row.semana ?? "-"}</TableCell>
                            <TableCell>{row.nivel ?? "-"}</TableCell>
                            <TableCell sx={{ maxWidth: 400 }}>
                              {row.mensagem.length > 80
                                ? `${row.mensagem.substring(0, 80)}...`
                                : row.mensagem}
                            </TableCell>
                            <TableCell>
                              <Tooltip title="Editar">
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    history.push(`/crm-gestante/mensagens/editar/${row.id}`)
                                  }
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Excluir">
                                <IconButton
                                  size="small"
                                  color="error"
                                  onClick={() => handleDelete(row.id)}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              )}
            </Container>
          )}
        </>
      )}
    </>
  );
};
